import { useEffect } from 'react';
import { gtmPushClientTrackingInfo } from 'common/utils/tracking';

function useClientTracking({ formId, initTrack }) {
    // NOTE: 這邊從 form api 取得到的 init track data uniqueName 是 partner uniqueName
    useEffect(() => {
        if (initTrack) {
            const {
                uniqueName,
                sponsorReportGA4MeasurementId,
                partnerReportGA4MeasurementId,
                customGA4MeasurementId,
                custom_FB_Pixel,
                lineTagId: custom_Line_TagId,
                custom_Adwords_Remarketing,
                sendPageView = 1
            } = initTrack;
            gtmPushClientTrackingInfo({
                formId,
                uniqueName,
                sponsorReportGA4MeasurementId,
                partnerReportGA4MeasurementId,
                customGA4MeasurementId,
                custom_FB_Pixel,
                custom_Line_TagId,
                custom_Adwords_Remarketing,
                sendPageView: Number(sendPageView)
            });
        }
    }, [formId, initTrack]);
}

export default useClientTracking;
